export var FormStatus;
(function (FormStatus) {
    FormStatus["DRAFT"] = "DRAFT";
    FormStatus["SUBMITTED"] = "SUBMITTED";
    FormStatus["APPROVED"] = "APPROVED";
    FormStatus["REJECTED"] = "REJECTED";
})(FormStatus || (FormStatus = {}));
